import { getPlugin as getBugsnagPlugin, startBugsnag } from '@app/bugsnag'
import router from '@app/router'
import { setupUI, trickleInjectionKey, useTrickle } from '@dailycare-au/ui'
import { createHead } from '@unhead/vue/client'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { DataLoaderPlugin } from 'vue-router/experimental'
import App from './app.vue'
import './tailwind.css'

startBugsnag()

const app = createApp(App)

app.use(getBugsnagPlugin('vue')!)
app.use(createHead())
app.use(createPinia())
app.provide(trickleInjectionKey, useTrickle())

app.use(DataLoaderPlugin, { router })
app.use(router)

setupUI(app)

app.mount('#app')
